var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{attrs:{"id":"components-layout-demo-top-side"}},[_c('a-layout-header',{staticClass:"header"},[_c('Navbar')],1),_vm._v(" "),_c('a-layout-content',{style:({ padding: '0 50px', minHeight: '780px' })},[_c('router-view')],1),_vm._v(" "),_c('a-layout-footer',{staticStyle:{"text-align":"center"}},[_c('Footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3915bdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NoSidebar.vue
// module id = null
// module chunks = 